module.exports = __webpack_public_path__ + "img/thumbnail_IndianRhinoceros_j_normal.d943c11e.png";